import EnvironmentSettings from './environment-settings';

export const environment: EnvironmentSettings = {
  production: false,

  hostNameEnglish: ['cfmh-dev-en.escolo.ca', ],
  hostNameFrench: ['cfmh-dev-fr.escolo.ca'],

  sessionTimeoutInSeconds: 900, // 15 min

  //cmsApiProtocol: 'http:',
  //cmsApiHostName: 'dev-cfmh-cms-api.escolo.ca',
  cmsApiProtocol: 'https:',
  cmsApiHostName: 'cfmh-comp.azurewebsites.net',
  cmsApiBasePath: '/api/resources/',

  itsrApiProtocol: 'https:',
  itsrApiHostName: 'slg-slgapi-ez-dev.azurewebsites.net',
  itsrApiBasePath: '/api/',

  subClassTotalPlan: 1077,
  subClassSystemsPlan: 1078,
  subClassAppliancePlan: 1079,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts